import { render, staticRenderFns } from "./admin-menu-sm.vue?vue&type=template&id=4d64e1e0&scoped=true&"
import script from "./admin-menu-sm.vue?vue&type=script&lang=js&"
export * from "./admin-menu-sm.vue?vue&type=script&lang=js&"
import style0 from "./admin-menu-sm.vue?vue&type=style&index=0&id=4d64e1e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d64e1e0",
  null
  
)

export default component.exports